import { css } from '@emotion/core';

export const customerStatFilterButtonContainerCSS = css`
    height: 2.5rem;
    display: inline-flex;
    justify-content: center;
    align-items: center;
`;

export const customerStatFilterButtonCSS = ({ colors }) => css`
    border-radius: 0.5rem;
    height: 2.3rem;
    width: 2.3rem;
    border: 0.1rem solid ${colors.neutral80};

    > svg {
        color: ${colors.neutral10};
        &:hover,
        &:active,
        &:focus {
            color: ${colors.neutral10};
        }
    }

    &:hover,
    &:active,
    &:focus {
        border: 0.1rem solid ${colors.neutral80};
        background-color: ${colors.neutral95};
    }
`;
export const customerStatFilterByApplicationSeeMoreCSS = css`
    display: flex;
`;

export const customerStatFilterContainerCSS = css`
    display: flex;
    height: 100%;
`;

export const customerStatFilterTopDownContainerCSS = css`
    display: block;
`;

export const customerStatFilterButtonWrapperCSS = css`
    position: relative;
    display: inline-flex;
`;

export const activeFilterBadgeCSS = ({ colors }) => css`
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    width: 1.125rem;
    height: 1.125rem;
    border-radius: 50%;
    background-color: ${colors.orange};
    color: ${colors.white};
    font-size: 0.75rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
`;
